import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ClientssoService } from '../services/clientsso.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private _authenticationService: AuthenticationService,
    private clientSsoService: ClientssoService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    if (this._authenticationService.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/vanguardlogin'], {
      queryParams: { returnUrl: state.url || '/landing' },
    });
    return false;
  }
}
